import kebabCase from 'lodash/kebabCase';

const formatStringForHookValue = kebabCase;

export { formatStringForHookValue };
